const LANGUAGES = {
  EN: {
    name: 'en',
  },
};

export default LANGUAGES;
